import { Trans, useTranslation } from "react-i18next";
import { useDeleteTarif } from "@/api/tarif.api";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { TarifReducedDto } from "@/types/api/api-types";
import { Loader2 } from "lucide-react";

interface TarifDeleteModalProps {
  open: boolean;
  closeModal: () => void;
  tarif: TarifReducedDto | null;
}

export const TarifDeleteModal = ({ open, closeModal, tarif }: TarifDeleteModalProps) => {
  const { t } = useTranslation(["boParameters", "common"]);
  const { mutateAsync: deleteTarif, isPending } = useDeleteTarif();

  const handleDeleteTarif = async () => {
    if (!tarif || isPending) return;
    await deleteTarif(tarif.id);
    closeModal();
  };

  return (
    <Modal
      open={open && !!tarif}
      onClose={closeModal}
      title={t("tarifDeleteModal.title")}
      size="sm"
      footer={
        <div className="flex w-full flex-col gap-2">
          <Button
            variant="destructive"
            disabled={isPending}
            onClick={handleDeleteTarif}
            className="w-full"
          >
            {isPending ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              t("tarifDeleteModal.submit")
            )}
          </Button>
          <Button variant="outline" onClick={closeModal} className="w-full">
            {t("common:actions.cancel")}
          </Button>
        </div>
      }
    >
      {tarif && (
        <p>
          <Trans
            t={t}
            i18nKey="tarifDeleteModal.description"
            values={{ label: tarif.label }}
            components={{ bold: <strong /> }}
          />
        </p>
      )}
    </Modal>
  );
};
